import { minutesToMilliseconds } from "date-fns";

import {
	getAdminSettingsHomeBranding,
	getAdminSettingsHomeFunctions,
	getAdminSettingsHomeSeatUsage,
	getAdminSettingsHomeSettings,
} from "../../services";

const queryScope = (companyId?: string) => companyId ?? "self";

export const adminSettingsHomeSeatUsageQuery = (companyId?: string) => ({
	queryKey: ["admin-settings-home", queryScope(companyId), "seat-usage"],
	queryFn: () => getAdminSettingsHomeSeatUsage(companyId),
	staleTime: minutesToMilliseconds(1),
});

export const adminSettingsHomeBrandingQuery = (companyId?: string) => ({
	queryKey: ["admin-settings-home", queryScope(companyId), "branding"],
	queryFn: () => getAdminSettingsHomeBranding(companyId),
});

export const adminSettingsHomeFunctionsQuery = (companyId?: string) => ({
	queryKey: ["admin-settings-home", queryScope(companyId), "functions"],
	queryFn: () => getAdminSettingsHomeFunctions(companyId),
});

export const adminSettingsHomeSettingsQuery = (companyId?: string) => ({
	queryKey: ["admin-settings-home", queryScope(companyId), "settings"],
	queryFn: () => getAdminSettingsHomeSettings(companyId),
});
